import React from 'react';
import { Switch } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Incident from './incident';
import Capa from './capa';
import Followup from './followup';
/* jhipster-needle-add-route-import - JHipster will add routes here */

const Routes = ({ match }) => (
  <>
    <Switch>
      {/* prettier-ignore */}
      <ErrorBoundaryRoute path={`${match.url}incident`} component={Incident} />
      <ErrorBoundaryRoute path={`${match.url}capa`} component={Capa} />
      <ErrorBoundaryRoute path={`${match.url}followup`} component={Followup} />
      {/* jhipster-needle-add-route-path - JHipster will add routes here */}
    </Switch>
  </>
);

export default Routes;
